// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file auth/v1/auth.proto (package auth.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file auth/v1/auth.proto.
 */
export const file_auth_v1_auth: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * Principal represents an authenticated identity.
 *
 * @generated from message auth.v1.Principal
 */
export type Principal = Message<"auth.v1.Principal"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: auth.v1.PrincipalType type = 2;
   */
  type: PrincipalType;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: auth.v1.AuthProvider auth_provider = 5;
   */
  authProvider: AuthProvider;

  /**
   * @generated from field: string provider_id = 6;
   */
  providerId: string;

  /**
   * @generated from field: string external_id = 7;
   */
  externalId: string;

  /**
   * @generated from field: repeated string roles = 8;
   */
  roles: string[];

  /**
   * @generated from field: map<string, string> metadata = 9;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_login_at = 12;
   */
  lastLoginAt?: Timestamp | undefined;
};

/**
 * Describes the message auth.v1.Principal.
 * Use `create(PrincipalSchema)` to create a new message.
 */
export const PrincipalSchema: GenMessage<Principal> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 0);

/**
 * APIKey represents an API key (without the secret).
 *
 * @generated from message auth.v1.APIKey
 */
export type APIKey = Message<"auth.v1.APIKey"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string principal_id = 2;
   */
  principalId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string prefix = 4;
   */
  prefix: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 5;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_used_at = 7;
   */
  lastUsedAt?: Timestamp | undefined;

  /**
   * @generated from field: bool revoked = 8;
   */
  revoked: boolean;
};

/**
 * Describes the message auth.v1.APIKey.
 * Use `create(APIKeySchema)` to create a new message.
 */
export const APIKeySchema: GenMessage<APIKey> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 1);

/**
 * AuthenticateAPIKeyRequest authenticates with an API key.
 *
 * @generated from message auth.v1.AuthenticateAPIKeyRequest
 */
export type AuthenticateAPIKeyRequest = Message<"auth.v1.AuthenticateAPIKeyRequest"> & {
  /**
   * @generated from field: string api_key = 1;
   */
  apiKey: string;
};

/**
 * Describes the message auth.v1.AuthenticateAPIKeyRequest.
 * Use `create(AuthenticateAPIKeyRequestSchema)` to create a new message.
 */
export const AuthenticateAPIKeyRequestSchema: GenMessage<AuthenticateAPIKeyRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 2);

/**
 * @generated from message auth.v1.AuthenticateAPIKeyResponse
 */
export type AuthenticateAPIKeyResponse = Message<"auth.v1.AuthenticateAPIKeyResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: string token_type = 3;
   */
  tokenType: string;

  /**
   * @generated from field: int64 expires_in = 4;
   */
  expiresIn: bigint;
};

/**
 * Describes the message auth.v1.AuthenticateAPIKeyResponse.
 * Use `create(AuthenticateAPIKeyResponseSchema)` to create a new message.
 */
export const AuthenticateAPIKeyResponseSchema: GenMessage<AuthenticateAPIKeyResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 3);

/**
 * RefreshTokenRequest exchanges a refresh token.
 *
 * @generated from message auth.v1.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"auth.v1.RefreshTokenRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message auth.v1.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 4);

/**
 * @generated from message auth.v1.RefreshTokenResponse
 */
export type RefreshTokenResponse = Message<"auth.v1.RefreshTokenResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: string token_type = 3;
   */
  tokenType: string;

  /**
   * @generated from field: int64 expires_in = 4;
   */
  expiresIn: bigint;
};

/**
 * Describes the message auth.v1.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema: GenMessage<RefreshTokenResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 5);

/**
 * RevokeTokenRequest invalidates a token.
 *
 * @generated from message auth.v1.RevokeTokenRequest
 */
export type RevokeTokenRequest = Message<"auth.v1.RevokeTokenRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message auth.v1.RevokeTokenRequest.
 * Use `create(RevokeTokenRequestSchema)` to create a new message.
 */
export const RevokeTokenRequestSchema: GenMessage<RevokeTokenRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 6);

/**
 * @generated from message auth.v1.RevokeTokenResponse
 */
export type RevokeTokenResponse = Message<"auth.v1.RevokeTokenResponse"> & {
};

/**
 * Describes the message auth.v1.RevokeTokenResponse.
 * Use `create(RevokeTokenResponseSchema)` to create a new message.
 */
export const RevokeTokenResponseSchema: GenMessage<RevokeTokenResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 7);

/**
 * ValidateTokenRequest checks token validity.
 *
 * @generated from message auth.v1.ValidateTokenRequest
 */
export type ValidateTokenRequest = Message<"auth.v1.ValidateTokenRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message auth.v1.ValidateTokenRequest.
 * Use `create(ValidateTokenRequestSchema)` to create a new message.
 */
export const ValidateTokenRequestSchema: GenMessage<ValidateTokenRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 8);

/**
 * @generated from message auth.v1.ValidateTokenResponse
 */
export type ValidateTokenResponse = Message<"auth.v1.ValidateTokenResponse"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: auth.v1.Principal principal = 2;
   */
  principal?: Principal | undefined;
};

/**
 * Describes the message auth.v1.ValidateTokenResponse.
 * Use `create(ValidateTokenResponseSchema)` to create a new message.
 */
export const ValidateTokenResponseSchema: GenMessage<ValidateTokenResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 9);

/**
 * CreateServiceAccountRequest creates a service account.
 *
 * @generated from message auth.v1.CreateServiceAccountRequest
 */
export type CreateServiceAccountRequest = Message<"auth.v1.CreateServiceAccountRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message auth.v1.CreateServiceAccountRequest.
 * Use `create(CreateServiceAccountRequestSchema)` to create a new message.
 */
export const CreateServiceAccountRequestSchema: GenMessage<CreateServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 10);

/**
 * @generated from message auth.v1.CreateServiceAccountResponse
 */
export type CreateServiceAccountResponse = Message<"auth.v1.CreateServiceAccountResponse"> & {
  /**
   * @generated from field: auth.v1.Principal principal = 1;
   */
  principal?: Principal | undefined;
};

/**
 * Describes the message auth.v1.CreateServiceAccountResponse.
 * Use `create(CreateServiceAccountResponseSchema)` to create a new message.
 */
export const CreateServiceAccountResponseSchema: GenMessage<CreateServiceAccountResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 11);

/**
 * CreatePreProvisionedUserRequest describes an account to create ahead of its
 * owner's first SSO login.
 *
 * @generated from message auth.v1.CreatePreProvisionedUserRequest
 */
export type CreatePreProvisionedUserRequest = Message<"auth.v1.CreatePreProvisionedUserRequest"> & {
  /**
   * email must match the address the IdP will assert. It is the only thing
   * login can match on before an external id exists, so a mismatch silently
   * produces a second, unprivileged account instead of activating this one.
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * display_name is optional; the email is used when empty.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * provider_id names the identity provider expected to bind this account.
   *
   * @generated from field: string provider_id = 3;
   */
  providerId: string;
};

/**
 * Describes the message auth.v1.CreatePreProvisionedUserRequest.
 * Use `create(CreatePreProvisionedUserRequestSchema)` to create a new message.
 */
export const CreatePreProvisionedUserRequestSchema: GenMessage<CreatePreProvisionedUserRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 12);

/**
 * @generated from message auth.v1.CreatePreProvisionedUserResponse
 */
export type CreatePreProvisionedUserResponse = Message<"auth.v1.CreatePreProvisionedUserResponse"> & {
  /**
   * @generated from field: auth.v1.Principal principal = 1;
   */
  principal?: Principal | undefined;

  /**
   * already_existed distinguishes a fresh create from an idempotent no-op, so a
   * roster import can report accurately instead of claiming to have created
   * accounts that were already there.
   *
   * @generated from field: bool already_existed = 2;
   */
  alreadyExisted: boolean;
};

/**
 * Describes the message auth.v1.CreatePreProvisionedUserResponse.
 * Use `create(CreatePreProvisionedUserResponseSchema)` to create a new message.
 */
export const CreatePreProvisionedUserResponseSchema: GenMessage<CreatePreProvisionedUserResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 13);

/**
 * GetPrincipalRequest retrieves a principal.
 *
 * @generated from message auth.v1.GetPrincipalRequest
 */
export type GetPrincipalRequest = Message<"auth.v1.GetPrincipalRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message auth.v1.GetPrincipalRequest.
 * Use `create(GetPrincipalRequestSchema)` to create a new message.
 */
export const GetPrincipalRequestSchema: GenMessage<GetPrincipalRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 14);

/**
 * @generated from message auth.v1.GetPrincipalResponse
 */
export type GetPrincipalResponse = Message<"auth.v1.GetPrincipalResponse"> & {
  /**
   * @generated from field: auth.v1.Principal principal = 1;
   */
  principal?: Principal | undefined;
};

/**
 * Describes the message auth.v1.GetPrincipalResponse.
 * Use `create(GetPrincipalResponseSchema)` to create a new message.
 */
export const GetPrincipalResponseSchema: GenMessage<GetPrincipalResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 15);

/**
 * ListPrincipalsRequest lists principals.
 *
 * @generated from message auth.v1.ListPrincipalsRequest
 */
export type ListPrincipalsRequest = Message<"auth.v1.ListPrincipalsRequest"> & {
  /**
   * @generated from field: auth.v1.PrincipalType type = 1;
   */
  type: PrincipalType;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message auth.v1.ListPrincipalsRequest.
 * Use `create(ListPrincipalsRequestSchema)` to create a new message.
 */
export const ListPrincipalsRequestSchema: GenMessage<ListPrincipalsRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 16);

/**
 * @generated from message auth.v1.ListPrincipalsResponse
 */
export type ListPrincipalsResponse = Message<"auth.v1.ListPrincipalsResponse"> & {
  /**
   * @generated from field: repeated auth.v1.Principal principals = 1;
   */
  principals: Principal[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message auth.v1.ListPrincipalsResponse.
 * Use `create(ListPrincipalsResponseSchema)` to create a new message.
 */
export const ListPrincipalsResponseSchema: GenMessage<ListPrincipalsResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 17);

/**
 * DeletePrincipalRequest removes a principal.
 *
 * @generated from message auth.v1.DeletePrincipalRequest
 */
export type DeletePrincipalRequest = Message<"auth.v1.DeletePrincipalRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message auth.v1.DeletePrincipalRequest.
 * Use `create(DeletePrincipalRequestSchema)` to create a new message.
 */
export const DeletePrincipalRequestSchema: GenMessage<DeletePrincipalRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 18);

/**
 * @generated from message auth.v1.DeletePrincipalResponse
 */
export type DeletePrincipalResponse = Message<"auth.v1.DeletePrincipalResponse"> & {
};

/**
 * Describes the message auth.v1.DeletePrincipalResponse.
 * Use `create(DeletePrincipalResponseSchema)` to create a new message.
 */
export const DeletePrincipalResponseSchema: GenMessage<DeletePrincipalResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 19);

/**
 * CreateAPIKeyRequest creates an API key.
 *
 * @generated from message auth.v1.CreateAPIKeyRequest
 */
export type CreateAPIKeyRequest = Message<"auth.v1.CreateAPIKeyRequest"> & {
  /**
   * @generated from field: string principal_id = 1;
   */
  principalId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message auth.v1.CreateAPIKeyRequest.
 * Use `create(CreateAPIKeyRequestSchema)` to create a new message.
 */
export const CreateAPIKeyRequestSchema: GenMessage<CreateAPIKeyRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 20);

/**
 * @generated from message auth.v1.CreateAPIKeyResponse
 */
export type CreateAPIKeyResponse = Message<"auth.v1.CreateAPIKeyResponse"> & {
  /**
   * @generated from field: auth.v1.APIKey api_key = 1;
   */
  apiKey?: APIKey | undefined;

  /**
   * Only returned once at creation
   *
   * @generated from field: string raw_key = 2;
   */
  rawKey: string;
};

/**
 * Describes the message auth.v1.CreateAPIKeyResponse.
 * Use `create(CreateAPIKeyResponseSchema)` to create a new message.
 */
export const CreateAPIKeyResponseSchema: GenMessage<CreateAPIKeyResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 21);

/**
 * ListAPIKeysRequest lists API keys.
 *
 * @generated from message auth.v1.ListAPIKeysRequest
 */
export type ListAPIKeysRequest = Message<"auth.v1.ListAPIKeysRequest"> & {
  /**
   * @generated from field: string principal_id = 1;
   */
  principalId: string;
};

/**
 * Describes the message auth.v1.ListAPIKeysRequest.
 * Use `create(ListAPIKeysRequestSchema)` to create a new message.
 */
export const ListAPIKeysRequestSchema: GenMessage<ListAPIKeysRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 22);

/**
 * @generated from message auth.v1.ListAPIKeysResponse
 */
export type ListAPIKeysResponse = Message<"auth.v1.ListAPIKeysResponse"> & {
  /**
   * @generated from field: repeated auth.v1.APIKey api_keys = 1;
   */
  apiKeys: APIKey[];
};

/**
 * Describes the message auth.v1.ListAPIKeysResponse.
 * Use `create(ListAPIKeysResponseSchema)` to create a new message.
 */
export const ListAPIKeysResponseSchema: GenMessage<ListAPIKeysResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 23);

/**
 * RevokeAPIKeyRequest revokes an API key.
 *
 * @generated from message auth.v1.RevokeAPIKeyRequest
 */
export type RevokeAPIKeyRequest = Message<"auth.v1.RevokeAPIKeyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message auth.v1.RevokeAPIKeyRequest.
 * Use `create(RevokeAPIKeyRequestSchema)` to create a new message.
 */
export const RevokeAPIKeyRequestSchema: GenMessage<RevokeAPIKeyRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 24);

/**
 * @generated from message auth.v1.RevokeAPIKeyResponse
 */
export type RevokeAPIKeyResponse = Message<"auth.v1.RevokeAPIKeyResponse"> & {
};

/**
 * Describes the message auth.v1.RevokeAPIKeyResponse.
 * Use `create(RevokeAPIKeyResponseSchema)` to create a new message.
 */
export const RevokeAPIKeyResponseSchema: GenMessage<RevokeAPIKeyResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 25);

/**
 * AuthProviderConfig contains the configuration for an auth provider.
 *
 * @generated from message auth.v1.AuthProviderConfig
 */
export type AuthProviderConfig = Message<"auth.v1.AuthProviderConfig"> & {
  /**
   * id is the unique provider identifier.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * name is the display name for the provider.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * type is the provider type (oidc, saml).
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * enabled indicates if the provider is active.
   *
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * client_id is the OAuth client ID (OIDC).
   *
   * @generated from field: string client_id = 5;
   */
  clientId: string;

  /**
   * client_secret is the OAuth client secret (OIDC, write-only).
   *
   * @generated from field: string client_secret = 6;
   */
  clientSecret: string;

  /**
   * issuer is the OIDC issuer URL for discovery.
   *
   * @generated from field: string issuer = 7;
   */
  issuer: string;

  /**
   * authorization_url is the authorization endpoint (optional, auto-discovered).
   *
   * @generated from field: string authorization_url = 8;
   */
  authorizationUrl: string;

  /**
   * token_url is the token endpoint (optional, auto-discovered).
   *
   * @generated from field: string token_url = 9;
   */
  tokenUrl: string;

  /**
   * userinfo_url is the userinfo endpoint (optional, auto-discovered).
   *
   * @generated from field: string userinfo_url = 10;
   */
  userinfoUrl: string;

  /**
   * scopes are the requested OAuth scopes.
   *
   * @generated from field: repeated string scopes = 11;
   */
  scopes: string[];

  /**
   * domains are email domains that route to this provider.
   *
   * @generated from field: repeated string domains = 12;
   */
  domains: string[];

  /**
   * domain_routing_enabled enables identifier-first login with domain routing.
   *
   * @generated from field: bool domain_routing_enabled = 13;
   */
  domainRoutingEnabled: boolean;

  /**
   * attribute_mappings map provider claims to Hub attributes.
   *
   * @generated from field: map<string, string> attribute_mappings = 14;
   */
  attributeMappings: { [key: string]: string };

  /**
   * default_roles are roles assigned to new users from this provider.
   *
   * @generated from field: repeated string default_roles = 15;
   */
  defaultRoles: string[];

  /**
   * created_at is when the provider was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */
  createdAt?: Timestamp | undefined;

  /**
   * updated_at is when the provider was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message auth.v1.AuthProviderConfig.
 * Use `create(AuthProviderConfigSchema)` to create a new message.
 */
export const AuthProviderConfigSchema: GenMessage<AuthProviderConfig> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 26);

/**
 * ListProvidersRequest requests all providers.
 *
 * @generated from message auth.v1.ListProvidersRequest
 */
export type ListProvidersRequest = Message<"auth.v1.ListProvidersRequest"> & {
  /**
   * include_disabled includes disabled providers.
   *
   * @generated from field: bool include_disabled = 1;
   */
  includeDisabled: boolean;
};

/**
 * Describes the message auth.v1.ListProvidersRequest.
 * Use `create(ListProvidersRequestSchema)` to create a new message.
 */
export const ListProvidersRequestSchema: GenMessage<ListProvidersRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 27);

/**
 * ListProvidersResponse returns providers.
 *
 * @generated from message auth.v1.ListProvidersResponse
 */
export type ListProvidersResponse = Message<"auth.v1.ListProvidersResponse"> & {
  /**
   * @generated from field: repeated auth.v1.AuthProviderConfig providers = 1;
   */
  providers: AuthProviderConfig[];
};

/**
 * Describes the message auth.v1.ListProvidersResponse.
 * Use `create(ListProvidersResponseSchema)` to create a new message.
 */
export const ListProvidersResponseSchema: GenMessage<ListProvidersResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 28);

/**
 * GetProviderRequest requests a specific provider.
 *
 * @generated from message auth.v1.GetProviderRequest
 */
export type GetProviderRequest = Message<"auth.v1.GetProviderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message auth.v1.GetProviderRequest.
 * Use `create(GetProviderRequestSchema)` to create a new message.
 */
export const GetProviderRequestSchema: GenMessage<GetProviderRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 29);

/**
 * GetProviderResponse returns the provider.
 *
 * @generated from message auth.v1.GetProviderResponse
 */
export type GetProviderResponse = Message<"auth.v1.GetProviderResponse"> & {
  /**
   * @generated from field: auth.v1.AuthProviderConfig provider = 1;
   */
  provider?: AuthProviderConfig | undefined;
};

/**
 * Describes the message auth.v1.GetProviderResponse.
 * Use `create(GetProviderResponseSchema)` to create a new message.
 */
export const GetProviderResponseSchema: GenMessage<GetProviderResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 30);

/**
 * CreateProviderRequest creates a new provider.
 *
 * @generated from message auth.v1.CreateProviderRequest
 */
export type CreateProviderRequest = Message<"auth.v1.CreateProviderRequest"> & {
  /**
   * @generated from field: auth.v1.AuthProviderConfig provider = 1;
   */
  provider?: AuthProviderConfig | undefined;
};

/**
 * Describes the message auth.v1.CreateProviderRequest.
 * Use `create(CreateProviderRequestSchema)` to create a new message.
 */
export const CreateProviderRequestSchema: GenMessage<CreateProviderRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 31);

/**
 * CreateProviderResponse returns the created provider.
 *
 * @generated from message auth.v1.CreateProviderResponse
 */
export type CreateProviderResponse = Message<"auth.v1.CreateProviderResponse"> & {
  /**
   * @generated from field: auth.v1.AuthProviderConfig provider = 1;
   */
  provider?: AuthProviderConfig | undefined;
};

/**
 * Describes the message auth.v1.CreateProviderResponse.
 * Use `create(CreateProviderResponseSchema)` to create a new message.
 */
export const CreateProviderResponseSchema: GenMessage<CreateProviderResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 32);

/**
 * UpdateProviderRequest updates a provider.
 *
 * @generated from message auth.v1.UpdateProviderRequest
 */
export type UpdateProviderRequest = Message<"auth.v1.UpdateProviderRequest"> & {
  /**
   * @generated from field: auth.v1.AuthProviderConfig provider = 1;
   */
  provider?: AuthProviderConfig | undefined;
};

/**
 * Describes the message auth.v1.UpdateProviderRequest.
 * Use `create(UpdateProviderRequestSchema)` to create a new message.
 */
export const UpdateProviderRequestSchema: GenMessage<UpdateProviderRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 33);

/**
 * UpdateProviderResponse returns the updated provider.
 *
 * @generated from message auth.v1.UpdateProviderResponse
 */
export type UpdateProviderResponse = Message<"auth.v1.UpdateProviderResponse"> & {
  /**
   * @generated from field: auth.v1.AuthProviderConfig provider = 1;
   */
  provider?: AuthProviderConfig | undefined;
};

/**
 * Describes the message auth.v1.UpdateProviderResponse.
 * Use `create(UpdateProviderResponseSchema)` to create a new message.
 */
export const UpdateProviderResponseSchema: GenMessage<UpdateProviderResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 34);

/**
 * DeleteProviderRequest deletes a provider.
 *
 * @generated from message auth.v1.DeleteProviderRequest
 */
export type DeleteProviderRequest = Message<"auth.v1.DeleteProviderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message auth.v1.DeleteProviderRequest.
 * Use `create(DeleteProviderRequestSchema)` to create a new message.
 */
export const DeleteProviderRequestSchema: GenMessage<DeleteProviderRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 35);

/**
 * DeleteProviderResponse confirms deletion.
 *
 * @generated from message auth.v1.DeleteProviderResponse
 */
export type DeleteProviderResponse = Message<"auth.v1.DeleteProviderResponse"> & {
};

/**
 * Describes the message auth.v1.DeleteProviderResponse.
 * Use `create(DeleteProviderResponseSchema)` to create a new message.
 */
export const DeleteProviderResponseSchema: GenMessage<DeleteProviderResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 36);

/**
 * TestProviderRequest tests provider connectivity.
 *
 * @generated from message auth.v1.TestProviderRequest
 */
export type TestProviderRequest = Message<"auth.v1.TestProviderRequest"> & {
  /**
   * id is the provider to test (if existing).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * config is the configuration to test (if not using existing provider).
   *
   * @generated from field: auth.v1.AuthProviderConfig config = 2;
   */
  config?: AuthProviderConfig | undefined;
};

/**
 * Describes the message auth.v1.TestProviderRequest.
 * Use `create(TestProviderRequestSchema)` to create a new message.
 */
export const TestProviderRequestSchema: GenMessage<TestProviderRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 37);

/**
 * TestProviderResponse returns test results.
 *
 * @generated from message auth.v1.TestProviderResponse
 */
export type TestProviderResponse = Message<"auth.v1.TestProviderResponse"> & {
  /**
   * success indicates if the test passed.
   *
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * message is the result message.
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * discovered_endpoints are OIDC discovered endpoints.
   *
   * @generated from field: auth.v1.DiscoveredEndpoints discovered_endpoints = 3;
   */
  discoveredEndpoints?: DiscoveredEndpoints | undefined;

  /**
   * errors are specific test failures.
   *
   * @generated from field: repeated string errors = 4;
   */
  errors: string[];
};

/**
 * Describes the message auth.v1.TestProviderResponse.
 * Use `create(TestProviderResponseSchema)` to create a new message.
 */
export const TestProviderResponseSchema: GenMessage<TestProviderResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 38);

/**
 * DiscoveredEndpoints contains OIDC discovered configuration.
 *
 * @generated from message auth.v1.DiscoveredEndpoints
 */
export type DiscoveredEndpoints = Message<"auth.v1.DiscoveredEndpoints"> & {
  /**
   * @generated from field: string authorization_endpoint = 1;
   */
  authorizationEndpoint: string;

  /**
   * @generated from field: string token_endpoint = 2;
   */
  tokenEndpoint: string;

  /**
   * @generated from field: string userinfo_endpoint = 3;
   */
  userinfoEndpoint: string;

  /**
   * @generated from field: string jwks_uri = 4;
   */
  jwksUri: string;

  /**
   * @generated from field: repeated string scopes_supported = 5;
   */
  scopesSupported: string[];

  /**
   * @generated from field: repeated string claims_supported = 6;
   */
  claimsSupported: string[];
};

/**
 * Describes the message auth.v1.DiscoveredEndpoints.
 * Use `create(DiscoveredEndpointsSchema)` to create a new message.
 */
export const DiscoveredEndpointsSchema: GenMessage<DiscoveredEndpoints> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 39);

/**
 * LookupProviderByDomainRequest looks up a provider by email domain.
 *
 * @generated from message auth.v1.LookupProviderByDomainRequest
 */
export type LookupProviderByDomainRequest = Message<"auth.v1.LookupProviderByDomainRequest"> & {
  /**
   * domain is the email domain (e.g., "acme.com").
   *
   * @generated from field: string domain = 1;
   */
  domain: string;
};

/**
 * Describes the message auth.v1.LookupProviderByDomainRequest.
 * Use `create(LookupProviderByDomainRequestSchema)` to create a new message.
 */
export const LookupProviderByDomainRequestSchema: GenMessage<LookupProviderByDomainRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 40);

/**
 * LookupProviderByDomainResponse returns the matching provider.
 *
 * @generated from message auth.v1.LookupProviderByDomainResponse
 */
export type LookupProviderByDomainResponse = Message<"auth.v1.LookupProviderByDomainResponse"> & {
  /**
   * found indicates if a provider was found.
   *
   * @generated from field: bool found = 1;
   */
  found: boolean;

  /**
   * provider is the matching provider (if found).
   *
   * @generated from field: auth.v1.AuthProviderConfig provider = 2;
   */
  provider?: AuthProviderConfig | undefined;
};

/**
 * Describes the message auth.v1.LookupProviderByDomainResponse.
 * Use `create(LookupProviderByDomainResponseSchema)` to create a new message.
 */
export const LookupProviderByDomainResponseSchema: GenMessage<LookupProviderByDomainResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 41);

/**
 * StartLoginRequest begins an external login. email is an optional domain hint.
 *
 * @generated from message auth.v1.StartLoginRequest
 */
export type StartLoginRequest = Message<"auth.v1.StartLoginRequest"> & {
  /**
   * @generated from field: string provider_id = 1;
   */
  providerId: string;

  /**
   * @generated from field: string redirect_url = 2;
   */
  redirectUrl: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;
};

/**
 * Describes the message auth.v1.StartLoginRequest.
 * Use `create(StartLoginRequestSchema)` to create a new message.
 */
export const StartLoginRequestSchema: GenMessage<StartLoginRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 42);

/**
 * @generated from message auth.v1.StartLoginResponse
 */
export type StartLoginResponse = Message<"auth.v1.StartLoginResponse"> & {
  /**
   * @generated from field: string auth_url = 1;
   */
  authUrl: string;

  /**
   * @generated from field: string state = 2;
   */
  state: string;
};

/**
 * Describes the message auth.v1.StartLoginResponse.
 * Use `create(StartLoginResponseSchema)` to create a new message.
 */
export const StartLoginResponseSchema: GenMessage<StartLoginResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 43);

/**
 * CompleteLoginRequest completes an external login from the callback. The state
 * token carries the provider; code is the OIDC authorization code.
 *
 * @generated from message auth.v1.CompleteLoginRequest
 */
export type CompleteLoginRequest = Message<"auth.v1.CompleteLoginRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string state = 2;
   */
  state: string;
};

/**
 * Describes the message auth.v1.CompleteLoginRequest.
 * Use `create(CompleteLoginRequestSchema)` to create a new message.
 */
export const CompleteLoginRequestSchema: GenMessage<CompleteLoginRequest> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 44);

/**
 * @generated from message auth.v1.CompleteLoginResponse
 */
export type CompleteLoginResponse = Message<"auth.v1.CompleteLoginResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: string token_type = 3;
   */
  tokenType: string;

  /**
   * @generated from field: int64 expires_in = 4;
   */
  expiresIn: bigint;

  /**
   * @generated from field: auth.v1.Principal principal = 5;
   */
  principal?: Principal | undefined;

  /**
   * @generated from field: bool is_new = 6;
   */
  isNew: boolean;
};

/**
 * Describes the message auth.v1.CompleteLoginResponse.
 * Use `create(CompleteLoginResponseSchema)` to create a new message.
 */
export const CompleteLoginResponseSchema: GenMessage<CompleteLoginResponse> = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 45);

/**
 * PrincipalType identifies the kind of authenticated entity.
 *
 * @generated from enum auth.v1.PrincipalType
 */
export enum PrincipalType {
  /**
   * @generated from enum value: PRINCIPAL_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRINCIPAL_TYPE_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: PRINCIPAL_TYPE_SERVICE_ACCOUNT = 2;
   */
  SERVICE_ACCOUNT = 2,

  /**
   * @generated from enum value: PRINCIPAL_TYPE_EDGE_NODE = 3;
   */
  EDGE_NODE = 3,
}

/**
 * Describes the enum auth.v1.PrincipalType.
 */
export const PrincipalTypeSchema: GenEnum<PrincipalType> = /*@__PURE__*/
  enumDesc(file_auth_v1_auth, 0);

/**
 * AuthProvider identifies the authentication method.
 *
 * @generated from enum auth.v1.AuthProvider
 */
export enum AuthProvider {
  /**
   * @generated from enum value: AUTH_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUTH_PROVIDER_OIDC = 1;
   */
  OIDC = 1,

  /**
   * @generated from enum value: AUTH_PROVIDER_SAML = 2;
   */
  SAML = 2,

  /**
   * @generated from enum value: AUTH_PROVIDER_API_KEY = 3;
   */
  API_KEY = 3,

  /**
   * @generated from enum value: AUTH_PROVIDER_CERTIFICATE = 4;
   */
  CERTIFICATE = 4,

  /**
   * @generated from enum value: AUTH_PROVIDER_LOCAL = 5;
   */
  LOCAL = 5,
}

/**
 * Describes the enum auth.v1.AuthProvider.
 */
export const AuthProviderSchema: GenEnum<AuthProvider> = /*@__PURE__*/
  enumDesc(file_auth_v1_auth, 1);

/**
 * AuthService provides authentication and identity management.
 *
 * @generated from service auth.v1.AuthService
 */
export const AuthService: GenService<{
  /**
   * AuthenticateAPIKey validates an API key and returns tokens.
   *
   * @generated from rpc auth.v1.AuthService.AuthenticateAPIKey
   */
  authenticateAPIKey: {
    methodKind: "unary";
    input: typeof AuthenticateAPIKeyRequestSchema;
    output: typeof AuthenticateAPIKeyResponseSchema;
  },
  /**
   * RefreshToken exchanges a refresh token for new tokens.
   *
   * @generated from rpc auth.v1.AuthService.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof RefreshTokenResponseSchema;
  },
  /**
   * RevokeToken invalidates a token.
   *
   * @generated from rpc auth.v1.AuthService.RevokeToken
   */
  revokeToken: {
    methodKind: "unary";
    input: typeof RevokeTokenRequestSchema;
    output: typeof RevokeTokenResponseSchema;
  },
  /**
   * ValidateToken checks if a token is valid.
   *
   * @generated from rpc auth.v1.AuthService.ValidateToken
   */
  validateToken: {
    methodKind: "unary";
    input: typeof ValidateTokenRequestSchema;
    output: typeof ValidateTokenResponseSchema;
  },
  /**
   * CreateServiceAccount creates a new service account.
   *
   * @generated from rpc auth.v1.AuthService.CreateServiceAccount
   */
  createServiceAccount: {
    methodKind: "unary";
    input: typeof CreateServiceAccountRequestSchema;
    output: typeof CreateServiceAccountResponseSchema;
  },
  /**
   * CreatePreProvisionedUser creates an account that an external identity
   * provider will bind to on the person's first login.
   *
   * Lets platform roles be managed on the platform side: an operator creates
   * the account and assigns its authz roles up front, and the IdP stays
   * responsible only for authentication. The alternative — deriving hub roles
   * from IdP group membership — would need a directory security group for
   * every role the platform will ever have.
   *
   * The account is inert until that first login: it carries no password and no
   * external id, so nothing can authenticate as it. Offboarding stays with the
   * IdP, since disabling the person there prevents any login at all.
   *
   * Idempotent — re-importing a roster returns the existing account unchanged,
   * including one that has already been activated.
   *
   * Named Create* deliberately: the authz interceptor derives admin:write from
   * that prefix (see methodAction). A name it does not recognise falls through
   * to execute.
   *
   * @generated from rpc auth.v1.AuthService.CreatePreProvisionedUser
   */
  createPreProvisionedUser: {
    methodKind: "unary";
    input: typeof CreatePreProvisionedUserRequestSchema;
    output: typeof CreatePreProvisionedUserResponseSchema;
  },
  /**
   * GetPrincipal retrieves a principal by ID.
   *
   * @generated from rpc auth.v1.AuthService.GetPrincipal
   */
  getPrincipal: {
    methodKind: "unary";
    input: typeof GetPrincipalRequestSchema;
    output: typeof GetPrincipalResponseSchema;
  },
  /**
   * ListPrincipals returns principals matching a filter.
   *
   * @generated from rpc auth.v1.AuthService.ListPrincipals
   */
  listPrincipals: {
    methodKind: "unary";
    input: typeof ListPrincipalsRequestSchema;
    output: typeof ListPrincipalsResponseSchema;
  },
  /**
   * DeletePrincipal removes a principal.
   *
   * @generated from rpc auth.v1.AuthService.DeletePrincipal
   */
  deletePrincipal: {
    methodKind: "unary";
    input: typeof DeletePrincipalRequestSchema;
    output: typeof DeletePrincipalResponseSchema;
  },
  /**
   * CreateAPIKey creates a new API key for a service account.
   *
   * @generated from rpc auth.v1.AuthService.CreateAPIKey
   */
  createAPIKey: {
    methodKind: "unary";
    input: typeof CreateAPIKeyRequestSchema;
    output: typeof CreateAPIKeyResponseSchema;
  },
  /**
   * ListAPIKeys returns all API keys for a principal.
   *
   * @generated from rpc auth.v1.AuthService.ListAPIKeys
   */
  listAPIKeys: {
    methodKind: "unary";
    input: typeof ListAPIKeysRequestSchema;
    output: typeof ListAPIKeysResponseSchema;
  },
  /**
   * RevokeAPIKey invalidates an API key.
   *
   * @generated from rpc auth.v1.AuthService.RevokeAPIKey
   */
  revokeAPIKey: {
    methodKind: "unary";
    input: typeof RevokeAPIKeyRequestSchema;
    output: typeof RevokeAPIKeyResponseSchema;
  },
  /**
   * StartLogin begins an external (OIDC/Entra) login, returning the provider
   * authorization URL and an opaque single-use state token. Public (it precedes
   * any token).
   *
   * @generated from rpc auth.v1.AuthService.StartLogin
   */
  startLogin: {
    methodKind: "unary";
    input: typeof StartLoginRequestSchema;
    output: typeof StartLoginResponseSchema;
  },
  /**
   * CompleteLogin completes an external login from the provider callback,
   * returning Hub tokens and the resolved principal. Public (it precedes any
   * token).
   *
   * @generated from rpc auth.v1.AuthService.CompleteLogin
   */
  completeLogin: {
    methodKind: "unary";
    input: typeof CompleteLoginRequestSchema;
    output: typeof CompleteLoginResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_auth_v1_auth, 0);

/**
 * AuthProviderService manages OAuth/OIDC provider configurations.
 *
 * @generated from service auth.v1.AuthProviderService
 */
export const AuthProviderService: GenService<{
  /**
   * ListProviders returns all configured auth providers.
   *
   * @generated from rpc auth.v1.AuthProviderService.ListProviders
   */
  listProviders: {
    methodKind: "unary";
    input: typeof ListProvidersRequestSchema;
    output: typeof ListProvidersResponseSchema;
  },
  /**
   * GetProvider returns a specific provider configuration.
   *
   * @generated from rpc auth.v1.AuthProviderService.GetProvider
   */
  getProvider: {
    methodKind: "unary";
    input: typeof GetProviderRequestSchema;
    output: typeof GetProviderResponseSchema;
  },
  /**
   * CreateProvider creates a new auth provider.
   *
   * @generated from rpc auth.v1.AuthProviderService.CreateProvider
   */
  createProvider: {
    methodKind: "unary";
    input: typeof CreateProviderRequestSchema;
    output: typeof CreateProviderResponseSchema;
  },
  /**
   * UpdateProvider updates an existing provider.
   *
   * @generated from rpc auth.v1.AuthProviderService.UpdateProvider
   */
  updateProvider: {
    methodKind: "unary";
    input: typeof UpdateProviderRequestSchema;
    output: typeof UpdateProviderResponseSchema;
  },
  /**
   * DeleteProvider removes a provider.
   *
   * @generated from rpc auth.v1.AuthProviderService.DeleteProvider
   */
  deleteProvider: {
    methodKind: "unary";
    input: typeof DeleteProviderRequestSchema;
    output: typeof DeleteProviderResponseSchema;
  },
  /**
   * TestProvider tests provider connectivity.
   *
   * @generated from rpc auth.v1.AuthProviderService.TestProvider
   */
  testProvider: {
    methodKind: "unary";
    input: typeof TestProviderRequestSchema;
    output: typeof TestProviderResponseSchema;
  },
  /**
   * LookupProviderByDomain finds a provider by email domain.
   *
   * @generated from rpc auth.v1.AuthProviderService.LookupProviderByDomain
   */
  lookupProviderByDomain: {
    methodKind: "unary";
    input: typeof LookupProviderByDomainRequestSchema;
    output: typeof LookupProviderByDomainResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_auth_v1_auth, 1);

